import script from "./SkewedButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SkewedButton.vue?vue&type=script&setup=true&lang=js"

import "./SkewedButton.vue?vue&type=style&index=0&id=71e5684e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e5684e"]])

export default __exports__